import pdfMake from 'pdfmake/build/pdfmake'
import type { Content, ContentText, TDocumentDefinitions } from 'pdfmake/interfaces'
import vfs from 'pdfmake/build/vfs_fonts.js'
import print from 'print-js'
import { formatCEP } from '@brazilian-utils/brazilian-utils'
import { ItemDaVenda, Pagamento, Venda } from '@/models'
import { formatarCnpjOuCpf, formatarMoeda, aplicarMascaraParaCpfOuCnpjOculto, aplicarMascaraParaEmail, aplicarMascaraParaTelefone } from '../formatadores'
import { dateTimeToPtBrFormat } from '../date/date-utils'
import { ReimpressaoModule } from '@/store/vuex/reimpressao/ReimpressaoStore'
import { obterTotalDeTaxas, obterValorDeFrete } from '../venda-shareds'
import { Decimal } from 'decimal.js'
import { detalharLojaPublico } from '@/api/lojas'
import { findValesPresentesByVendaIdPublico } from '@/api/valepresente'
import { ValePresente } from '@/models/views/ValePresente'

window.pdfMake.vfs = vfs.pdfMake.vfs

const SETE = 7
const CENTER = 'center'


async function gerarDocumentoParaImpressaoPublico(venda: Venda, lojaId: string): Promise<string> {
	const lojaAtualizada = await detalharLojaPublico(lojaId)
	const valesPresentes = await findValesPresentesByVendaIdPublico(venda.id)
	console.log("depois vale")
	try {
		const configLoja = lojaAtualizada.configuracaoDaLoja
		const itensValidosDaVenda = venda.itens.filter((item) => item.motivoCancelamento === null)
		const numerosSorteados = (venda.numerosDoSorteio || [])
			.map(numero => numero.numeroSorteado)
			.filter(Boolean)
		const docDefinition: TDocumentDefinitions = {
			pageSize: {
				width: 230,
				height: 500,
			},
			pageOrientation: 'portrait',
			pageMargins: [ 3, 5, 5, 5 ],
			content: [
				{ text: `${lojaAtualizada.nomeFantasia || ''}\n`, fontSize: 8, bold: true, alignment: CENTER },
				{ text: `CNPJ: ${formatarCnpjOuCpf(lojaAtualizada.cnpj || '')}     IE: ${lojaAtualizada.inscricaoEstadual || ''}\n`, style: 'labels' },
				{ text: `${lojaAtualizada.endereco.rua || ''}, ${lojaAtualizada.endereco.numero || ''}, CEP ${formatCEP(lojaAtualizada.endereco.cep || '')}\n`, style: 'labels' },
				{ text: `Bairro: ${lojaAtualizada.endereco.bairro || ''}   Cidade/UF: ${lojaAtualizada.endereco.cidade || ''} - ${lojaAtualizada.endereco.uf || ''}\n`, style: 'labels' },
				{ text: `Fone: ${lojaAtualizada.telefones ? lojaAtualizada.telefones[0] : 'Não consta.'}\n`, style: 'labels' },
				{ canvas: [{ type: 'line', x1: 0, y1: 0, x2: 225, y2: 0, lineWidth: 0.2 }], fontSize: SETE },
			configLoja?.tipoDeCodigo == 'Sku'
				?
				buildTabelaDosItensDaVenda(itensValidosDaVenda || [], venda, [
					{ text: 'sku', style: 'tableColumns' },
					{ text: 'descricaoDoProduto', style: 'tableColumns' },
					{ text: 'preco', style: 'tableColumns' },
					{ text: 'quantidade', style: 'tableColumns' },
					{ text: 'valorTotalPorItem', style: 'tableColumns' },
				])
				:
				buildTabelaDosItensDaVenda(itensValidosDaVenda || [], venda, [
					{ text: 'ean', style: 'tableColumns' },
					{ text: 'descricaoDoProduto', style: 'tableColumns' },
					{ text: 'preco', style: 'tableColumns' },
					{ text: 'quantidade', style: 'tableColumns' },
					{ text: 'valorTotalPorItem', style: 'tableColumns' },
				]),
			buildTabelaDasFormasDePagamento(venda.pagamentos || [], [
				{ text: 'formaDePagamento', style: 'tableColumns' },
				{ text: 'valorPago', style: 'tableColumns' },
			]),
			{
				alignment: 'justify',
				columns:[
					{text: venda.troco > 0 ? 'Troco' : '', fontSize: 7, margin:[4,0] },
					{text: venda.troco > 0 ? `R$ ${formatarMoeda(venda.troco) || ''}`: '', alignment: 'right', fontSize: 7 },
				],
			},

			{ canvas: [{ type: 'line', x1: 0, y1: 0, x2: 225, y2: 0, lineWidth: 0.2 }], fontSize: SETE },
			{ text: `Emitido em ${dateTimeToPtBrFormat(venda.dataHora || '')}\n`, style: 'labels' },
			{ text: `Ponto de venda: ${venda.pontoDeVenda?.nome}\n`, style: 'labels' },
			...(numerosSorteados.length > 0
				? [{ text: `Números do sorteio: ${numerosSorteados.join(', ')}\n`, style: 'labels' }]
				: []),
			{ text: `Venda: ${venda.identificador}\n`, style: 'labels' },
			{ canvas: [{ type: 'line', x1: 0, y1: 0, x2: 225, y2: 0, lineWidth: 0.2 }], fontSize: SETE },
			{ text: `Consumidor: ${venda.cliente?.razaoSocialOuNome || ''}`, style: 'labels' },
			{ text: `CPF/CNPJ: ${aplicarMascaraParaCpfOuCnpjOculto(venda.cpfDoCliente || venda.cliente?.cnpjOuCpf || '')}`, style: 'labels' },
			{ text: `E-mail: ${aplicarMascaraParaEmail(venda.cliente?.email || 'Não informado.')}`, style: 'labels' },
			{ text: `Fone: ${aplicarMascaraParaTelefone((venda.cliente?.telefones || [])[0] || 'Não consta.')}`, style: 'labels' },
			{ canvas: [{ type: 'line', x1: 0, y1: 0, x2: 225, y2: 0, lineWidth: 0.2 }], fontSize: SETE },
			buildQrCode(valesPresentes),
			(valesPresentes && valesPresentes.length > 0 ? { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 225, y2: 0, lineWidth: 0.2 }], margin: [0, 5, 0, 0], fontSize: SETE } : []),
			],
			styles: {
				labels: {
					fontSize: SETE,
					alignment: CENTER,
				},
				tableColumns: {
					bold: true,
					fontSize: SETE,
				},
			},
		}
		console.log("depois doc")

		const titulo = `Venda: ${[
			venda.identificador,
			aplicarMascaraParaCpfOuCnpjOculto(venda.cpfDoCliente || venda.cliente?.cnpjOuCpf || ''),
			venda.cliente?.razaoSocialOuNome,
		]
			.filter(e => e)
			.join(', ')}`

		ReimpressaoModule.addReimpressao({ titulo, docDefinition })
		return new Promise(
			resolve => pdfMake.createPdf(docDefinition).getBase64((result) => resolve(result)),
		)
	} catch (e) {
		console.error('Erro ao gerar documento:', e)
		throw e
	}
}

export async function imprimirCupomSemValorFiscalPublico(venda: Venda, lojaId: string): Promise<void> {
	const cupomSemValorFiscal: string = await gerarDocumentoParaImpressaoPublico(venda, lojaId)
	console.log("cupom", cupomSemValorFiscal)
	return new Promise((resolve, reject) => {
		print({
			printable: cupomSemValorFiscal,
			type: 'pdf',
			base64: true,
			onError: reject,
			onLoadingEnd: resolve,
		})
	})
}

function buildTabelaDasFormasDePagamento(pagamentos: Pagamento[], colunas: ContentText[]) {
	return {
		table: {
			headerRows: 1,
			widths: [ 120, 90 ],
			body: buildCorpoDaTabelaDasFormasDePagamento(pagamentos, colunas),
		},
		layout: {
			hLineWidth: () => 0,
			vLineWidth: () => 0,
		},
	}
}

function buildQrCode(valesPresentes: ValePresente[]): Content[] {
	const body: Content[] = []

	valesPresentes.forEach(vale => {
		body.push({
			table: {
				widths: ['auto', '*'],
				body: [
					[
						{
							qr: vale.identificador,
							fit: 80,
							margin: [0, 5, 3, 0],
						},
						{
							text: `
								Código: ${formatCodigo(vale.identificador)}
								Valor do vale-presente: R$${formatarMoeda(vale.valor)}
							`,
							style: 'labels',
							margin: [0, 0, 0, 0],
							alignment: 'left',
						},
					],
				],
			},
			layout: 'noBorders',
		});
	});

	return body;
}

function formatCodigo(id: string) {
	const part1 = id.substring(0, 8);
	const part2 = id.substring(id.length - 4);
	return `${part1}...${part2}`;
}

function buildTabelaDosItensDaVenda(itensDaVenda: ItemDaVenda[], venda: Venda, colunas: ContentText[]) {
	return {
		table: {
			headerRows: 1,
			widths: [ 43, 67, 23, 22, 32 ],
			body: buildCorpoDaTabelaDosItensDaVenda(itensDaVenda, venda, colunas),
		},
		layout: {
			hLineWidth: () => 0,
			vLineWidth: () => 0,
		},
	}
}

function buildCorpoDaTabelaDasFormasDePagamento(pagamentos: Pagamento[], colunas: ContentText[]) {
	const body: ContentText[][] = []
	pagamentos.forEach(pagamento => {
		const dataRow: ContentText[] = []
		colunas.forEach(coluna => {
			let conteudoDaLinha = pagamento[coluna.text as string]
			if (coluna.text === 'formaDePagamento') {
				const formaDePagamento = pagamento.tipoDePagamento?.formaDePagamento
				conteudoDaLinha = formaDePagamento !== pagamento.tipoDePagamento?.nome
					? `${formaDePagamento || ''} - ${pagamento.tipoDePagamento?.nome || ''}`
					: formaDePagamento || ''
			}
			if (coluna.text === 'valorPago') {
				conteudoDaLinha = `R$ ${formatarMoeda(pagamento.valor)}`
			}
			dataRow.push({
				text: conteudoDaLinha,
				bold: false,
				fontSize: SETE,
				alignment: coluna.text === 'valorPago' ? 'right' : 'left',
			})
		})
		body.push(dataRow)
	})
	return body
}

function buildCorpoDaTabelaDosItensDaVenda(itensDaVenda: ItemDaVenda[], venda: Venda, colunas: ContentText[]) {
	const body: ContentText[][] = []
	const colunasDaTabelaDeItens: ContentText[] = [
		{ text: 'Cód.', style: 'tableColumns' },
		{ text: 'Descrição', style: 'tableColumns' },
		{ text: 'V. Unit.', style: 'tableColumns', alignment: 'right' },
		{ text: 'Qtd.', style: 'tableColumns', alignment: 'right' },
		{ text: 'V. Total', style: 'tableColumns', alignment: 'right' },
	]
	body.push(colunasDaTabelaDeItens)
	itensDaVenda.forEach(itemDaVenda => {
		const dataRow: ContentText[] = []
		colunas.forEach(coluna => {
			let conteudoDaLinha = coluna.text === 'preco'
				? `${formatarMoeda(Number(itemDaVenda[coluna.text]))}`
				: itemDaVenda[coluna.text as string]
			if (coluna.text === 'sku') {
				conteudoDaLinha = itemDaVenda.produto?.sku || ''
			}
			if (coluna.text === 'ean') {
				conteudoDaLinha = (itemDaVenda.produto?.eans || [])[0] || ''
			}
			if (coluna.text === 'descricaoDoProduto') {
				conteudoDaLinha = itemDaVenda.produto?.nome || ''
			}
			if (coluna.text === 'valorTotalPorItem') {
				conteudoDaLinha = `${valorTotalPorItem(itemDaVenda)}`
			}
			dataRow.push({
				text: conteudoDaLinha,
				bold: false,
				fontSize: SETE,
				alignment: coluna.text === 'valorTotalPorItem' ||
					coluna.text === 'preco' ||
					coluna.text === 'quantidade' ? 'right' : 'left',
			})
		})
		body.push(dataRow)
	})

	body.push(obterDescontoTotalDaVenda(venda))
	if (venda.informacoesDeTransporte?.valorFrete && venda.informacoesDeTransporte.valorFrete > 0) {
		body.push(obterFreteDaVenda(venda))
	}
	body.push(obterValorTotalDosItensDaVenda(venda))
	return body
}

function obterDescontoTotalDaVenda(venda: Venda): ContentText[] {
	console.log("obterDescontoTotalDaVenda")
	const itensValidosDaVenda = venda.itens.filter((item) => item.motivoCancelamento === null)
	const descontoTotal = obterDescontoItensValidosPedido(itensValidosDaVenda)
	return [
		{ text: 'Desconto', bold: false, fontSize: 8 },
		{ text: '', bold: true, fontSize: 7 },
		{ text: '', bold: true, fontSize: 7 },
		{ text: ``, bold: true, fontSize: 8 },
		{ text: `${descontoTotal > 0 ? '-' : ''}${formatarMoeda(descontoTotal)}`, bold: false, fontSize: 8, alignment: 'right' },
	]
}

function obterFreteDaVenda(venda: Venda): ContentText[] {
	const freteDaVenda = venda.informacoesDeTransporte.valorFrete ? venda.informacoesDeTransporte.valorFrete : 0
	return [
		{ text: 'Frete', bold: false, fontSize: 8 },
		{ text: '', bold: true, fontSize: 7 },
		{ text: '', bold: true, fontSize: 7 },
		{ text: ``, bold: true, fontSize: 8 },
		{ text: `${formatarMoeda(freteDaVenda)}`, bold: false, fontSize: 8, alignment: 'right' },
	]
}

function obterValorTotalDosItensDaVenda(venda: Venda): ContentText[] {
	const itensValidosDaVenda = venda.itens.filter((item) => item.motivoCancelamento === null)
	const descontoTotal = obterDescontoItensValidosPedido(itensValidosDaVenda)
	const valorUnitarioTotal = itensValidosDaVenda.reduce(
		(total, { quantidade, preco }) => total.add(new Decimal(quantidade).mul(preco)), new Decimal(0))
		.toNumber()
	const valorTotalComDesconto = (valorUnitarioTotal - descontoTotal)
	let quantidadeTotalDeItens: string | number = itensValidosDaVenda.reduce(
		(total, { quantidade }) => total + quantidade, 0,
	)
	const valorTotalDaTaxa = obterTotalDeTaxas(venda)

	quantidadeTotalDeItens = Number.isInteger(quantidadeTotalDeItens)
		? quantidadeTotalDeItens
		: quantidadeTotalDeItens.toFixed(2)
	return [
		{ text: 'TOTAL (R$)', bold: true, fontSize: 8 },
		{ text: '', bold: true, fontSize: 7 },
		{ text: '', bold: true, fontSize: 7 },
		{ text: `${quantidadeTotalDeItens}`, bold: true, fontSize: 8, alignment: 'right' },
		{ text: `${formatarMoeda(valorTotalComDesconto + valorTotalDaTaxa + obterValorDeFrete(venda))}`, bold: true, fontSize: 8, alignment: 'right' },
	]
}

function valorTotalPorItem(itemDaVenda: ItemDaVenda) {
	return formatarMoeda(new Decimal(itemDaVenda.preco).mul(itemDaVenda.quantidade).toNumber())
}

function obterDescontoItensValidosPedido(itensValidos: ItemDaVenda[]) {
	return itensValidos.reduce((total, itemValido) => total + (itemValido.valorDescontoRateadoDoItem || 0), 0)
}
